import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import ColorIndicator from 'further-ui/components/ColorIndicator';
import { Column, Row } from 'further-ui/components/Layout';
import React from 'react';

const PaddedBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(theme.spacingSizes.xs),
}));

type Props = React.ComponentProps<typeof ColorIndicator> & {
  text: string;
  subtext?: string;
};

const ColorIndicatorWithText: React.FC<Props> = ({
  text,
  subtext,
  ...colorIndicatorProps
}) => {
  return (
    <Row centered spacing="xs">
      <PaddedBox>
        <ColorIndicator {...colorIndicatorProps} />
      </PaddedBox>
      <Column>
        <Typography variant="inherit">{text}</Typography>
        {subtext ? <Typography variant="body2">{subtext}</Typography> : null}
      </Column>
    </Row>
  );
};

export default ColorIndicatorWithText;
